
import React from 'react';
import { motion } from "framer-motion";

const SolutionsHeader = () => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="text-center mb-12"
    >
      <h1 className="text-4xl font-bold text-gray-800 dark:text-white mb-4">
        Our Solutions
      </h1>
      <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
        Discover our comprehensive range of solutions designed to transform your business
        and drive success in the digital age.
      </p>
    </motion.div>
  );
};

export default SolutionsHeader;
